import { useMountEffect } from "primereact/hooks";
export default useMountEffect;
